import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { getInsights } from "@/lib/api";

export default function Insights() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    getInsights().then((r) => setItems(r.items || [])).catch(() => setItems([]));
  }, []);

  return (
    <main className="min-h-screen pt-28 pb-24 px-4 sm:px-6" data-testid="insights-page">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-clay mb-4">insights</p>
          <h1 className="font-serif text-4xl sm:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] max-w-4xl" data-testid="insights-title">
            New research, calibrated. <span className="italic text-sage">Most studies change nothing.</span>
          </h1>
          <p className="mt-5 text-slatem max-w-2xl leading-relaxed">
            Answer-first explainers, reviewed by clinicians, honest about limitations. When evidence does not change your plan, we say so.
          </p>
        </Reveal>

        {!items ? (
          <div className="mt-20 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-clay" /></div>
        ) : (
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="insights-grid">
            {items.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.06}>
                <Link to={`/insights/${a.slug}`} data-testid={`insights-card-${a.slug}`}
                  className="group flex flex-col rounded-md border-2 border-ink/12 bg-bone overflow-hidden h-full transition-colors duration-300 hover:border-ink">
                  <div className="overflow-hidden aspect-[16/10]">
                    <img src={a.image} alt={a.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <div className="flex items-center gap-3 mb-3 font-mono text-[10px] uppercase tracking-[0.18em] text-slatem">
                      <span className="text-clay">{a.label}</span><span>·</span><span className="text-sage">Grade {a.grade}</span><span>·</span><span>{a.read_minutes} min</span>
                    </div>
                    <h2 className="font-serif text-xl sm:text-2xl font-bold uppercase tracking-tight leading-tight mb-2 group-hover:text-clay transition-colors duration-200">{a.title}</h2>
                    <p className="text-sm text-slatem leading-relaxed line-clamp-3">{a.dek}</p>
                    <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-ink/70 group-hover:text-clay transition-colors">
                      Read <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
